import { Component, OnInit, AfterViewInit, Renderer2, ViewEncapsulation } from "@angular/core";
import {
  Router,
  RouteConfigLoadStart,
  RouteConfigLoadEnd
} from "@angular/router";
import { GenericService } from "./services/generic.service";
import { CookieService } from "ngx-cookie-service";
import { app } from "./app";
import { appconfig } from "./appconfig";
import { HomeinitService } from "./services/homeinit.service";
import { AlertsConfig } from "global-navigation/src/app/pru-nav/pru-nav.component";
import { applicationConfig } from "./applicationConfig";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Rx";

import { DeferredWarmupService } from './services/deferred-warmup/deferred-warmup.service';
import { LinkService } from './services/link.service';

declare let window;
declare var $: any;
declare var dtrum: any;
declare var environment: any;

@Component({
  selector: "pru-framework",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit {
  dataObj: app;
  entitlement: string;
  containerIndex: number;
  entitlements: string[];
  logout: string;
  logresponse: any;
  appConfig: any;
  parentDataObj: app;
  appConfigArr: appconfig[];
  config: any;
  configError: boolean = false;
  navigation: any;
  configOfTimeout: any;
  private alertsConfig: AlertsConfig;
  private profileName: string = "";
  usr_ext_agg: boolean = false;
  usr_rspar: boolean = false;
  user_pruco: boolean = false;
  user_pma = false;
  usr_FEDERATED: boolean = false;
  userHasSia = false;
  retirementDomain = environment.RETIREMENT_DOMAIN;
  redesign: boolean = false;
  showComponents: boolean = false;

  /**
   *
   * @param _genericService
   * @param _cookieService
   */
  public constructor(
    private renderer: Renderer2,
    public _genericService: GenericService,
    private _cookieService: CookieService,
    private _linkService: LinkService,
    private router: Router,
    public homeinitService: HomeinitService,
    private deferredWarmupService: DeferredWarmupService,
  ) { }
  ngOnInit(): void {
    /*expose jquery $ to window*/
    window["$"] = window["jQuery"] = $;
    this._genericService.toggleObs$.subscribe((res: any) => {
      this.redesign = res;
      if (this.redesign) {
        this.renderer.addClass(document.body, "redesign-view");
      }
    });



    this._genericService.checkLogOutCookie();
    this.navigation = this.getNavigation(new Subject<any>());

    this.alertsConfig = {
      alertMessagesUrl:
        "/onprem/api/co/secure/myaccounts/alerts/v1/alertmessages?channel=inbox",
      alertMessageReadUrl:
        "/api/co/secure/myaccounts/alerts/v1/alertmessages/messageread"
    };

    this.config = applicationConfig;
    this.configOfTimeout = applicationConfig.timeoutconfig;

    this.containerIndex = 0;
    this.appConfigArr = [];

    this.parentDataObj = this.homeinitService.appConfiguration;

    if (this.parentDataObj) {
      if (this.parentDataObj.ddo) {
        if (/csr/i.test(this.parentDataObj.ddo.userType)) {
          this.renderer.addClass(document.body, "csrview");
          this._genericService.usr_csr = true;
        }
        if (/INDV_RESERVED_CUSTOMER/i.test(this.parentDataObj.ddo["role"])) {
          this.usr_FEDERATED = true;
        }
      }

      if (this.parentDataObj.buNames) {
        let strBuNames = JSON.stringify({
          content: this.parentDataObj.buNames
        });
        sessionStorage.setItem("userBUs", strBuNames);
        this._genericService.userBUs = this.parentDataObj.buNames;

        this.usr_ext_agg = strBuNames.indexOf("AGG") > -1;
        this.usr_rspar = strBuNames.indexOf("Retirement") > -1;
        this.userHasSia = strBuNames.indexOf("SIA") > -1;
        this.user_pruco = strBuNames.indexOf("PRUCO") > -1;
        this.user_pma = strBuNames.indexOf("BYC") > -1;

        this._genericService.usr_rspar = this.usr_rspar;

        // console.log('agguser', this.usr_ext_agg);
        this._genericService.setExtAggUser(this.usr_ext_agg);
      }
      if (this.parentDataObj.appName === "fallback") {
        this.configError = true;
      }
    }

    this.dataObj = this.parentDataObj;

    this.dataObj.appConfig = [];
    this.dataObj.appConfig = this.config.appConfig;
    let currentDDO: any = null;
    if (sessionStorage.getItem("currentDdo")) {
      currentDDO = JSON.parse(sessionStorage.getItem("currentDdo"));
    } else {
      currentDDO = {
        authenticated: true,
        page: { category: { pageType: "" } },
        user: {
          profile: { profileInfo: { pruId: "", userType: "", legacyssoId: "" } }
        }
      };
    }
    currentDDO["authenticated"] = true;
    if (this.dataObj.ddo) {
      if (this.dataObj.ddo.SSOUSERDATA) {
        let legacySSOID = "";
        let basedOnIndv = this.dataObj.ddo.SSOUSERDATA.split("^");
        for (let index = 0; index < basedOnIndv.length; index++) {
          let basedOnPipe = basedOnIndv[index].split("|"),
            basedOnEqual = basedOnPipe ? basedOnPipe[0].split("=") : [];
          if (basedOnEqual.length >= 2 && /^indv$/i.test(basedOnEqual[0])) {
            legacySSOID = legacySSOID ? legacySSOID + "|" : legacySSOID;
            legacySSOID += basedOnPipe[1].charAt(0) + ":" + basedOnEqual[1];
          }
        }
        currentDDO.user.profile.profileInfo["legacyssoId"] = legacySSOID;
      }
      currentDDO.page.category["pageType"] =
        this.dataObj.appName === "home" ? "My Accounts" : "Auth Platform";
      currentDDO.user.profile.profileInfo["pruId"] = this.dataObj.ddo.ssoId;
      this._genericService.userSsoid = this.dataObj.ddo.ssoId;
      currentDDO.user.profile.profileInfo[
        "userType"
      ] = this.dataObj.ddo.userType;
      this._genericService.xPruId =
        currentDDO.user.profile.profileInfo["pruId"];
      currentDDO.user.profile.profileInfo[
        "userName"
      ] = this.homeinitService.appConfiguration.profile.firstName;
      currentDDO.user.profile.profileInfo[
        "coUserId"
      ] = this.homeinitService.appConfiguration.profile.coUserId;
    }
    currentDDO = JSON.stringify(currentDDO);

    sessionStorage.setItem("currentDdo", currentDDO);

    let PruImpersonatedIdentity = null;
    PruImpersonatedIdentity =
      /csr/i.test(location.host) &&
        this._cookieService.get("X-PruImpersonatedIdentity")
        ? this._cookieService.get("X-PruImpersonatedIdentity")
        : null;
    let userssoid = PruImpersonatedIdentity
      ? PruImpersonatedIdentity
      : this.dataObj.ddo
        ? this.dataObj.ddo.ssoId
        : "";
    if (typeof dtrum !== "undefined") {
      dtrum.identifyUser(userssoid);
    }

    if (this.homeinitService.appConfiguration.appName !== "fallback") {
      if (
        this.homeinitService.appConfiguration.responseStatus !== "Success" ||
        this.homeinitService.appConfiguration.responseCode > 428 ||
        !this.homeinitService.appConfiguration.profile
      ) {
        this.configError = true;
      } else {
        this.configError = false;
        this.profileName = this.homeinitService.appConfiguration.profile
          .prefferedName
          ? this.homeinitService.appConfiguration.profile.prefferedName
          : this.homeinitService.appConfiguration.profile.firstName;

        this._genericService.userName = this.profileName;
      }
    }

    // Decide if BU level container(s) need to be displyed.
    for (let x = 0; x < this.parentDataObj.buNames.length; x++) {
      for (let y = 0; y < this.dataObj.appConfig.length; y++) {
        if (
          this.parentDataObj.buNames[x] ===
          this.dataObj.appConfig[y].entitlement
        ) {
          this.dataObj.appConfig[y].visibility = true;

          break;
        }
      }
    }

    if (this.dataObj.appName) {
      this._genericService.updateAppName(this.dataObj.appName);
    }

    this.appConfig = this.config.appConfig;
    if (this.appConfig) {
      let aggbucket = this.appConfig.filter(item=>item.aggregationBucket);
      if(aggbucket.length){
        this._genericService.updateAggrData(aggbucket[0].aggregationBucket);
      }
    }
    this.containerIndex = 0;
    let entitleKey: string[] = [];
    for (let j = 0; j < this.appConfig.length; j++) {
      entitleKey.push(this.appConfig[j].entitlement);
      if (
        this.appConfig[j].visibility &&
        this.appConfig[j].genericService === "Y"
      ) {
        this.containerIndex++;
      }
    }
    this._genericService.updateContainerCount(this.containerIndex);

    //  this.deferredWarmupService.init();

    this._linkService.triggerGoalsCheck();
  }

  ngAfterViewInit(): void { }

  maLogoutFn = () => {
    let logouturl = this._cookieService.get("MYACCTLOGOUT");
    this.logout = logouturl ? logouturl : "/ucd/logout/logout.html";
    window.sessionStorage.clear();
    window.location.href = this.logout;
  };

  /**
   * To Get the navigation.
   */
  getNavigation(navigation: any): Observable<any> {
    return Observable.create(observer => {
      // let hostname = window.location.host;
      navigation =
        environment && environment.environment
          ? applicationConfig["navigation_" + environment.environment]
          : applicationConfig.navigation_prod;
      // navigation = applicationConfig.navigation_prod;
      // if (/myaccounts.prudential.com/i.test(hostname)) {
      //   navigation = applicationConfig.navigation_prod;
      // } else if (/stage/i.test(hostname)) {
      //   navigation = applicationConfig.navigation_stage;
      // } else if (/ite/i.test(hostname)) {
      //   navigation = applicationConfig.navigation_ite;
      // } else if (/qa/i.test(hostname)) {
      //   navigation = applicationConfig.navigation_qa;
      // } else if (/dev/i.test(hostname)) {
      //   navigation = applicationConfig.navigation_dev;
      // }
      observer.next(navigation);
      observer.complete();
    });
  }
}
